export default "__VITE_ASSET__32146c8f__"